import _ from 'lodash';
import '@patsnap-biz/design-tokens/scss/_tooltip.scss';
import Tooltip from 'element-ui/lib/tooltip';
import { Toast } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/tick.svg';
import { DetailServiceSymbol } from '@/services/DetailService';
import $ from 'jquery';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { useFolder } from '@/presentation/composables/folder/use-folder';
export const name = 'PN_TITLE.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const i18n = injectService(i18nSymbol);
    const { row } = params;
    const { savePatent, rowPatentId } = renderOpts;
    const getAlreadyInCurrentSpace = _.get(renderOpts, '_column._props.getAlreadyInCurrentSpace', () => false);
    // TODO: BIO_UK这里应该移除了，后面看需不需要加
    const { PN, PATENT_ID } = row || {};
    const detailService = injectService(DetailServiceSymbol);
    const { folderPermission } = useFolder();
    const hasEditFolderPermission = folderPermission.value.enable_edit_query;
    const patentsData = _.get(detailService, 'viewData.patents_data', []);
    const rowIndex = _.findIndex(patentsData, { PATENT_ID: rowPatentId });
    const savePnToWorkspace = (e) => {
        savePatent(PATENT_ID).then(() => {
            if (!hasEditFolderPermission)
                return;
            // 保存成功，实现图标过度动画
            const icon = $(e.target).parents('.pn-cell').find('.patsnap-biz-icon')[0];
            icon.innerHTML = '<use href="#SolidTick"></use>';
            icon.classList.add('transition-icon-hide');
            setTimeout(() => {
                icon.classList.add('icon-hide');
            }, 1000);
        }).catch(err => {
            Toast({
                message: err._error_msg,
                type: 'error',
                showClose: true,
                dangerouslyUseHTMLString: true,
            });
        });
    };
    const folderIcon = <Tooltip effect="dark" visible-arrow={false} popper-class="pt-ui-tooltip" placement="top" content={hasEditFolderPermission ? i18n.t('familyPatent.saveToCurrentFolder') : i18n.t('familyPatent.noFolderPermission')}>
        <svg class={`in-current-space patsnap-biz-icon ${hasEditFolderPermission ? '' : 'disabled'}`} onClick={(e) => savePnToWorkspace(e)} id={`patent_id_${PATENT_ID}`}>
            <use href="#SolidFolderClosed2"></use>
        </svg></Tooltip>;
    const pnLink = <p class="pn-cell patsnap-biz-patent_field--pn patsnap-biz-patent_field h-6">
        <a class="patsnap-biz-mark" target="_blank" data-patent-id={PATENT_ID} data-link-type="PN" data-link-data={PN} data-patent-no={PN} data-row-index={rowIndex}>{PN}</a> {getAlreadyInCurrentSpace(row) ? null : folderIcon}
    </p>;
    const vnodes = [pnLink];
    return [<div data-vxe-render={name}>{vnodes}</div>];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
